import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Chevron Up"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-chevron-up',
    templateUrl: './icon-chevron-up.component.html',
    styleUrls: ['./icon-chevron-up.component.scss'],
    standalone: false
})
export class IconChevronUpComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
